module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/jobgroup/jobgroup-view/jobgroup-view.component.css
// module id = ./src/app/technical/jobgroup/jobgroup-view/jobgroup-view.component.css
// module chunks = main